type StoryTypeChecker = {
  text?: string | null | undefined
  videoUri?: string | null | undefined
}

export const isTextStory = (story: StoryTypeChecker): boolean => {
  return Boolean(story?.text) && !story?.videoUri
}

export const isVideoStory = (story: StoryTypeChecker): boolean => {
  return Boolean(story?.videoUri)
}

export const hasNoStory = (story: StoryTypeChecker): boolean => {
  return !isTextStory(story) && !isVideoStory(story)
}

export type PlayableStory = {
  id?: string | null
  projectName?: string
  isMyStory?: boolean
  isFromActor?: boolean
  text?: string | null
  userAvatar?: string | null
  userName?: string | null
  videoUri?: string | null
  userId: string
  publishDate?: string | null
  totalLikes?: number | null
  isLikedByUser?: boolean | null
  momentId?: string | null
}
